import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"

//i18n
import { withTranslation } from "react-i18next"
import axios from "axios"

const NotificationDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const [approvals, setApprovals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [state, setState] = useState({});

  const fetchData = () =>{
   
  }

  useEffect(() => {
    fetchData();
    return () => {
      setState({}); 
    };
  }, []);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon "
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-bell bx-tada" />
          <span className="badge bg-danger rounded-pill">{approvals.length}</span>
        </DropdownToggle>
        {(approvals.length > 0) && (
        <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0 dropdown-menu-end">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Notifications")} </h6>
              </Col>
              <div className="col-auto">
                <a href="/leave-approvals" className="small">
                  View All
                </a>
              </div>
            </Row>
          </div>
     
          
          <SimpleBar style={{ height: "230px" }}>
          {(approvals.length > 0) && approvals.map((item,key) => (
                  <Link to="" className="text-reset notification-item" key={key} >
                    <div className="media">
                      <div className="avatar-xs me-3">
                        <span className="avatar-title bg-primary rounded-circle font-size-16">
                          <i className="bx bx-bell" />
                        </span>
                      </div>
                      <div className="media-body">
                        <h6 className="mt-0 mb-1"> {item.DocumentNo} </h6>
                        <div className="font-size-12 text-muted">
                          <p className="mb-1">
                            {item.EmployeeName}
                          </p>
                          <p className="mb-0">
                            <i className="mdi mdi-clock-outline" />{" "}
                            {item.DateTimeSentforApproval}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                  ))} 
          </SimpleBar>
          
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              to="/leave-approvals"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>
              View all
            </Link>
          </div>
        </DropdownMenu>
        )}
      </Dropdown>
    </React.Fragment>
  )
}

export default withTranslation()(NotificationDropdown)

NotificationDropdown.propTypes = {
  t: PropTypes.any
}